<template>
  <div v-if="isLoaded" id="hrs-details">
    <JSONView :data="details" root-key="HRS Booking" :max-depth="1" />
  </div>
</template>

<script>
import CommonApi from '@/api/commonApi'
import { JSONView } from 'vue-json-component'

export default {
  components: {
    JSONView
  },

  props: {
    entity: Object
  },

  data () {
    return {
      isLoaded: false,
      details: null
    }
  },

  created () {
    if (this.entity.is_online) {
      let commonApi = new CommonApi()
      commonApi.getHrsBookingDetail(this.entity.id)
        .then( response => { this.details = response.data })
        .then( () => this.isLoaded = true )
    }
  }
}
</script>

<style lang="scss">
  #hrs-details {
    .properties {
      display: none;
    }
  }
</style>
